/* eslint-disable max-len */
import React from "react";

const IcArrowBack = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.9583 8.29171L5.55746 8.2917L8.12871 5.20337C8.18824 5.13175 8.23309 5.0491 8.26068 4.96014C8.28827 4.87119 8.29807 4.77767 8.28952 4.68492C8.27225 4.49762 8.18128 4.32485 8.03663 4.20462C7.89197 4.08439 7.70548 4.02655 7.51818 4.04381C7.33088 4.06108 7.15811 4.15205 7.03788 4.29671L3.49621 8.5467C3.47238 8.58051 3.45108 8.61602 3.43246 8.65296C3.43246 8.68837 3.39704 8.70962 3.38288 8.74504C3.35077 8.82625 3.33396 8.91271 3.33329 9.00004C3.33396 9.08737 3.35077 9.17382 3.38288 9.25504C3.38288 9.29045 3.41829 9.3117 3.43246 9.34712C3.45108 9.38405 3.47238 9.41957 3.49621 9.45337L7.03788 13.7034C7.10448 13.7833 7.18788 13.8476 7.28214 13.8917C7.37641 13.9358 7.47923 13.9585 7.58329 13.9584C7.7488 13.9587 7.90919 13.9011 8.03663 13.7955C8.10835 13.736 8.16764 13.663 8.2111 13.5805C8.25456 13.4981 8.28133 13.408 8.28988 13.3152C8.29844 13.2224 8.2886 13.1289 8.26095 13.0399C8.23329 12.9509 8.18835 12.8683 8.12871 12.7967L5.55746 9.70837L13.9583 9.70837C14.1462 9.70837 14.3263 9.63374 14.4592 9.50091C14.592 9.36807 14.6666 9.1879 14.6666 9.00004C14.6666 8.81218 14.592 8.63201 14.4592 8.49917C14.3263 8.36633 14.1462 8.29171 13.9583 8.29171Z"
        fill="currentColor"
      />
    </svg>

  )
}

export default IcArrowBack;